<template>
    <main id="profile_main" class="page" role="main">
        <section class="user-communities" v-if="['userCommunityPosts', 'userCommunityLikes'].includes($route.name)">
            <div class="o-wrapper">
                <div class="o-grid">
                    <div class="o-grid__item u-width-full">
                        <div class="user-communities__wrap">
                            <a :href="'/u/' + $root.profile.username" class="user-communities__back">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
                                    <path d="M8 1L1 7.5L8 14" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p>Back to {{$root.profile.first_name}}'s communities</p>
                            </a>

                            <div class="user-communities__images">
                                <img :src="$root.profile.avatar" alt="User pic">
                                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="18" viewBox="0 0 27 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M26.0665 8.6986C25.9706 4.35236 22.2287 0.906582 17.7088 1.00193C16.1729 1.03443 14.7454 1.47255 13.5332 2.20622C15.8991 3.63708 17.4443 6.19528 17.3691 9.07571C17.2977 11.8145 15.7794 14.189 13.5351 15.5432C14.8432 16.3324 16.3969 16.7764 18.0565 16.7411C19.4383 16.712 20.7316 16.3539 21.8605 15.7484C23.5217 17.2044 25.7713 16.7377 25.7713 16.7377C24.8471 15.649 24.5958 14.3543 24.5532 13.4296C25.5398 12.0972 26.1056 10.459 26.0665 8.6986Z" stroke="black" stroke-width="1.26469"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.6987 9.04459C9.63541 6.1752 11.1775 3.63142 13.5334 2.20607C12.3299 1.47792 10.9147 1.04072 9.39102 1.0027C4.87143 0.889879 1.11603 4.32155 1.00261 8.66749C0.956861 10.4279 1.51582 12.0679 2.49744 13.4043C2.45107 14.329 2.19477 15.6225 1.2661 16.7078C1.2661 16.7078 3.51415 17.1831 5.18099 15.7332C6.30736 16.343 7.59948 16.706 8.9812 16.7403C10.6524 16.782 12.2184 16.3381 13.5353 15.5431C11.2813 14.1834 9.75948 11.795 9.6987 9.04459Z" stroke="black" stroke-width="1.26469"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3697 9.07554C17.4449 6.19511 15.8997 3.63692 13.5338 2.20605C11.178 3.6314 9.63585 6.17519 9.69914 9.04457C9.75993 11.795 11.2817 14.1834 13.536 15.5431C15.78 14.1889 17.2986 11.8143 17.3697 9.07554Z" stroke="black" stroke-width="1.26469"/>
                                </svg>
                                <img :src="$root.community.image" :alt="$root.community.name">
                            </div>
                            <!-- TODO -->
                            <h1>
                                {{$root.profile.first_name}} in <a :href="'/' + $root.community.url">{{$root.community.title}}</a>
                            </h1>

                            <div class="user-communities__accredited" v-if="$root.profile.accredited_community === $root.community.id">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                                    <path d="M13.0678 1.87572L12.6127 2.46668L13.0678 1.87572C12.4384 1.39102 11.5616 1.39102 10.9322 1.87572L9.45555 3.01297L9.81993 3.48609L9.45555 3.01297C9.40604 3.0511 9.34404 3.06931 9.28177 3.064L7.42469 2.90562C6.63319 2.83812 5.89551 3.3122 5.62811 4.06021L5.00072 5.81526C4.97968 5.87411 4.93737 5.92295 4.88211 5.95214L3.23421 6.82292C2.53187 7.19405 2.1676 7.99169 2.34705 8.76553L2.76811 10.5812C2.78223 10.642 2.77303 10.706 2.74233 10.7604L1.82681 12.3839L2.47756 12.7509L1.82681 12.3839C1.43661 13.0758 1.5614 13.9438 2.13074 14.4978L3.46656 15.7975C3.51135 15.8411 3.53819 15.8999 3.5418 15.9623L3.64932 17.823C3.69515 18.6161 4.26939 19.2788 5.04784 19.437L6.87431 19.8082C6.93556 19.8207 6.98992 19.8556 7.02668 19.9061L8.12312 21.4133C8.59042 22.0557 9.43178 22.3028 10.1722 22.015L11.9094 21.3398L11.6378 20.6408L11.9094 21.3398C11.9677 21.3172 12.0323 21.3172 12.0906 21.3398L12.3622 20.6408L12.0906 21.3398L13.8278 22.015C14.5682 22.3028 15.4096 22.0557 15.8769 21.4133L16.9733 19.9061C17.0101 19.8556 17.0644 19.8207 17.1257 19.8082L18.9522 19.437C19.7306 19.2788 20.3048 18.6161 20.3507 17.823L20.4582 15.9623C20.4618 15.8999 20.4887 15.8411 20.5334 15.7975L21.8693 14.4978C22.4386 13.9438 22.5634 13.0758 22.1732 12.3839L21.2577 10.7604C21.227 10.706 21.2178 10.642 21.2319 10.5812L21.6529 8.76553C21.8324 7.99169 21.4681 7.19405 20.7658 6.82292L19.1179 5.95214C19.0626 5.92295 19.0203 5.87411 18.9993 5.81526L18.3719 4.06021C18.1045 3.3122 17.3668 2.83812 16.5753 2.90562L14.7182 3.064C14.656 3.06931 14.594 3.0511 14.5444 3.01297L13.0678 1.87572Z" fill="#DB2848" stroke="#F3F3F3" stroke-width="1.5" />
                                    <path d="M9 11.7419L11.1538 14L15 9" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                                <p>Accredited writer</p>
                            </div>

                            <div class="user-communities__stats">
                                <div class="user-communities__stat" @click="toggleFollowersMenu">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                                        <circle cx="9.5" cy="5.5" r="4.75" stroke="black" stroke-width="1.5" />
                                        <path d="M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z" stroke="black" stroke-width="1.5" />
                                    </svg>
                                    <p v-html="$root.stats.followers + ' follower' + ($root.stats.followers !== 1 ?  + 's' : '')"></p>
                                </div>

                                <div class="user-communities__stat" @click="toggleFollowingMenu">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                                        <circle cx="9.5" cy="5.5" r="4.75" stroke="black" stroke-width="1.5" />
                                        <path d="M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z" stroke="black" stroke-width="1.5" />
                                    </svg>
                                    <p>{{$root.stats.following}} following</p>
                                </div>
                            </div>

                            <Menu
                                :show-menu="showFollowersMenu"
                                :scroll-class="scrollClass"
                                :close-event="closeProfileFollowersMenuEvent"
                                :top="true"
                            >
                                <div>
                                    <div class="menu__title">
                                        <p>Followers</p>
                                    </div>

                                    <div class="menu__search">
                                        <div class="search">
                                            <input type="search" name="search" id="search" placeholder="Search what you love...">
                                        </div>
                                    </div>

                                    <div class="menu__items">
                                        <div class="following">
                                            <img :src="$cdn('/img2.0/avatar-example.png')" alt="User pic">
                                            <div class="following__details">
                                                <p>
                                                    {{$root.profile.first_name}} {{$root.profile.surname}}
                                                    <span>@{{$root.profile.username}}</span>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="following">
                                            <img :src="$cdn('/img2.0/avatar-example.png')" alt="User pic">
                                            <div class="following__details">
                                                <p>
                                                    {{$root.profile.first_name}} {{$root.profile.surname}}
                                                    <span>@{{$root.profile.username}}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Menu>

                            <Menu
                                :show-menu="showFollowingMenu"
                                :scroll-class="scrollClass"
                                :close-event="closeProfileFollowingMenuEvent"
                                :top="true"
                            >
                                <div>
                                    <div class="menu__title">
                                        <p>Following</p>
                                    </div>

                                    <div class="menu__search">
                                        <div class="search">
                                            <input type="search" name="search" id="search" placeholder="Search what you love...">
                                        </div>
                                    </div>

                                    <div class="menu__items">
                                        <div class="following">
                                            <img :src="$cdn('/img2.0/avatar-example.png')" alt="User pic">
                                            <div class="following__details">
                                                <p>
                                                    {{$root.profile.first_name}} {{$root.profile.surname}}
                                                    <span>@{{$root.profile.username}}</span>
                                                </p>
                                            </div>
                                            <a href="#" class="following__follow">
                                                <p>Follow</p>
                                            </a>
                                        </div>

                                        <div class="following">
                                            <img :src="$cdn('/img2.0/avatar-example.png')" alt="User pic">
                                            <div class="following__details">
                                                <p>
                                                    {{$root.profile.first_name}} {{$root.profile.surname}}
                                                    <span>@{{$root.profile.username}}</span>
                                                </p>
                                            </div>
                                            <a
                                                href="#"
                                                class="following__unfollow"
                                            >
                                                <p>Unfollow</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </Menu>
                        </div>

                        <div class="user-communities__links">
                            <div class="tabs u-m-b4 u-m-b0@s">
                                <router-link
                                    :to="'/u/' + $root.profile.username + '/' + $root.community.url + '/posts'"
                                    v-slot="{
                                        href,
                                        route,
                                        navigate,
                                        isActive,
                                        isExactActive,
                                    }"
                                >
                                    <div>
                                        <a :href="href" @click="navigate">
                                            <h4 :class="[!isExactActive && 'inactive',]">
                                                Posts
                                            </h4>
                                        </a>
                                    </div>
                                </router-link>
                                <router-link
                                    :to="'/u/' + $root.profile.username + '/' + $root.community.url + '/likes'"
                                    v-slot="{
                                        href,
                                        route,
                                        navigate,
                                        isActive,
                                        isExactActive,
                                    }"
                                >
                                    <div>
                                        <a :href="href" @click="navigate">
                                            <h4 :class="[!isExactActive && 'inactive',]">
                                                Likes
                                            </h4>
                                        </a>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="profile" v-else>
            <div class="o-wrapper">
                <div class="o-grid">
                    <div class="o-grid__item u-width-full">
                        <div class="profile__wrap">
                            <div class="profile__details">
                                <div class="profile__img" v-if="$root.community !== false">
                                    <img :src="$root.community.image" :alt="$root.community.title">
                                    <img
                                        v-bind="avatarAttrs"
                                        width="120"
                                        height="120"
                                        :alt="$root.profile.first_name + ' ' + $root.profile.surname"
                                        class="user"
                                    >
                                </div>
                                <div class="profile__img" v-else>
                                    <img
                                        v-bind="avatarAttrs"
                                        width="120"
                                        height="120"
                                        :alt="$root.profile.first_name + ' ' + $root.profile.surname"
                                    >
                                </div>

                                <div class="profile__content">
                                    <div class="profile__content-user">
                                        <h5 v-if="this.$route.name !== 'Drafts'">
                                            <span>
                                                <strong v-html="$root.profile.first_name + ' ' + $root.profile.surname"></strong>
                                            </span>
                                            <span>
                                                <a :href="'/u/' + $root.profile.username" v-html="$root.profile.username !== '' ? '@' + $root.profile.username : ''"></a>
                                            </span>
                                            <span v-if="$root.community !== false" class="community">
                                                <a :href="'/' + $root.community.url">{{$root.community.title}}</a>
                                            </span>
                                        </h5>
                                        <h5 class="u-hidden u-block@m" v-if="$route.name === 'Drafts'">
                                            <span>
                                                <strong v-html="$root.profile.first_name + ' ' + $root.profile.surname"></strong>
                                            </span>
                                            <span>
                                                <a :href="'/u/' + $root.profile.username" v-html="$root.profile.username !== '' ? '@' + $root.profile.username : ''"></a>
                                            </span>
                                            <span v-if="$root.community !== false">
                                                <a :href="'/' + $root.community.url">{{$root.community.title }}</a>
                                            </span
                                            >
                                        </h5>
                                        <div class="profile__actions">
                                            <template v-if="$root.isOwnAccount">
                                                <a href="/settings" class="button__edit">
                                                    <p>Edit Profile</p>
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a v-show="isFollowing === false" @click.prevent="followUser($root.profile.user_id)" class="button__follow" href="#">
                                                    <p>Follow</p>
                                                </a>
                                                <a v-show="isFollowing === true" @click.prevent="unfollowUser($root.profile.user_id)" class="button__following" href="#">
                                                    <svg width="72" height="32" viewBox="0 0 72 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="72" height="32" rx="16" fill="#47AAC0"/>
                                                        <path d="M37 23.6772C37.4017 22.1406 38.322 20.7725 39.6191 19.7837C40.9162 18.7948 42.5181 18.2401 44.1782 18.2049C45.8383 18.1697 47.4646 18.656 48.8064 19.5888C50.1483 20.5217 51.1314 21.8494 51.6044 23.3675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M44.6678 15.1797H43.9352C43.0173 15.1797 42.137 14.8319 41.4879 14.2129C40.8389 13.5938 40.4742 12.7543 40.4742 11.8788V11.5767C40.4742 10.6281 40.8693 9.71836 41.5726 9.04762C42.2759 8.37687 43.2297 8.00006 44.2243 8.00006C44.7377 7.99957 45.2462 8.09566 45.7206 8.28281C46.1951 8.46997 46.6262 8.74452 46.9892 9.09077C47.3522 9.43701 47.6401 9.84814 47.8364 10.3006C48.0326 10.7531 48.1333 11.2381 48.1328 11.7277V11.8788C48.1328 12.7543 47.7682 13.5938 47.1191 14.2129C46.47 14.8319 45.5897 15.1797 44.6718 15.1797H44.6678Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M18 16.4839L22.3077 21L30 11" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                </a>
                                            </template>
                                            <div class="card__menu" @click="toggleCommunitiesMenu">
                                                <div class="dots">
                                                    <div class="dot"></div>
                                                </div>
                                            </div>
                                            <Menu
                                                :show-menu="showCommunitiesMenu"
                                                :close-event="closeProfileCommunitiesMenuEvent"
                                                :top="true"
                                            >
                                                <div>
                                                    <div class="menu__links">
                                                        <a href="#" @click.prevent="toggleFollowersMenu">
                                                            View followers
                                                        </a>
                                                        <a href="#" @click.prevent="toggleFollowingMenu">
                                                            View following
                                                        </a>
                                                    </div>
                                                </div>
                                            </Menu>
                                        </div>
                                    </div>
                                    <div class="profile__content-stats">
                                        <div :class="['profile__stat']">
                                            <a href="#" @click.prevent="toggleFollowersMenu">
                                                <svg width="33" height="20" viewBox="0 0 33 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="16.5" cy="5.5" r="4.75" stroke="black" stroke-width="1.5"/>
                                                    <path d="M8.44689 16.3762C9.78824 13.05 12.9034 10.75 16.5 10.75C20.0966 10.75 23.2118 13.05 24.5531 16.3762C24.8478 17.107 24.6742 17.7862 24.2018 18.3182C23.713 18.8686 22.9029 19.25 22 19.25H11C10.0971 19.25 9.287 18.8686 8.79822 18.3182C8.32581 17.7862 8.15219 17.107 8.44689 16.3762Z" stroke="black" stroke-width="1.5"/>
                                                    <path d="M11.9523 4.5C11.3173 3.02931 9.85397 2 8.15022 2C5.86405 2 4.01074 3.85331 4.01074 6.13947C4.01074 7.68807 4.86111 9.03805 6.12036 9.74794C6.72013 10.086 7.41264 10.2789 8.15022 10.2789C8.81468 10.2789 9.44257 10.1224 9.99902 9.84416C11.0462 9.32054 11.8404 8.36599 12.1491 7.21293" stroke="black" stroke-width="1.5"/>
                                                    <path d="M10.0569 9.79688C11.143 10.1125 12.1254 10.691 12.9385 11.4633M6.09593 9.84143C4.35884 10.3889 2.89938 11.6129 1.9936 13.2228C0.910334 15.1481 2.79086 17.0525 5 17.0525H8.35938" stroke="black" stroke-width="1.5"/>
                                                    <path d="M20.9871 4.5C21.6221 3.02931 23.0855 2 24.7892 2C27.0754 2 28.9287 3.85331 28.9287 6.13947C28.9287 7.68807 28.0783 9.03805 26.8191 9.74794C26.2193 10.086 25.5268 10.2789 24.7892 10.2789C24.1248 10.2789 23.4969 10.1224 22.9404 9.84416C21.8932 9.32054 21.0991 8.36599 20.7903 7.21293" stroke="black" stroke-width="1.5"/>
                                                    <path d="M22.8825 9.79688C21.7965 10.1125 20.814 10.691 20.001 11.4633M26.8435 9.84143C28.5806 10.3889 30.0401 11.6129 30.9459 13.2228C32.0291 15.1481 30.1486 17.0525 27.9395 17.0525H24.5801" stroke="black" stroke-width="1.5"/>
                                                </svg>
                                            </a>
                                            <a href="#" @click.prevent="toggleFollowersMenu">
                                                <span>{{$root.stats.followers}}</span>
                                                Followers
                                            </a>
                                        </div>
                                        <div :class="['profile__stat']">
                                            <a href="#" @click.prevent="toggleFollowingMenu">
                                                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="9.5" cy="5.5" r="4.75" stroke="black" stroke-width="1.5"/>
                                                    <path d="M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z" stroke="black" stroke-width="1.5"/>
                                                </svg>
                                            </a>
                                            <a href="#" @click.prevent="toggleFollowingMenu">
                                                <span v-html="followingStats"></span>
                                                Following
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="profile__search" ref="communitySearch">
                                <div class="search">
                                    <span :class="['search__icon', { 'search__icon--loading': searchLoading }]" aria-hidden="true">
                                        <svg class="search__icon-glass" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5"/>
                                            <line x1="11.5" y1="11.5" x2="15" y2="15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                        </svg>
                                        <svg class="search__icon-spinner" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="26 9"/>
                                        </svg>
                                    </span>
                                    <input
                                        type="text"
                                        v-model="searchCommunity"
                                        @keyup="getInput"
                                        class="search"
                                        :placeholder="searchPlaceholder"
                                    >
                                    <span
                                        @click="clearInput"
                                        :class="['search__clear', searchActive ? 'search__active' : '']"
                                        aria-label="Clear search"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                            <div class="profile__links">
                                <div class="tabs u-m-b4 u-m-b0@s">
                                    <router-link
                                        v-if="$root.community === false"
                                        :to="
                                            '/u/' +
                                            $root.profile.username +
                                            ($root.community !== false
                                                ? '/' + $root.community.url
                                                : '')
                                        "
                                        v-slot="{
                                            href,
                                            route,
                                            navigate,
                                            isActive,
                                            isExactActive,
                                        }"
                                    >
                                        <div>
                                            <a :href="href" @click="navigate">
                                                <h4 :class="[!isExactActive && 'inactive',]">
                                                    Communities
                                                </h4>
                                            </a>
                                        </div>
                                    </router-link>
                                    <router-link
                                        :to="
                                            '/u/' +
                                            $root.profile.username +
                                            ($root.community !== false
                                                ? '/' + $root.community.url
                                                : '') +
                                            '/posts'
                                        "
                                        v-slot="{
                                            href,
                                            route,
                                            navigate,
                                            isActive,
                                            isExactActive,
                                        }"
                                    >
                                        <div>
                                            <a :href="href" @click="navigate">
                                                <h4 :class="[!isExactActive && $route.name !== 'userDrafts' && 'inactive',]">
                                                    <span v-if="$root.isOwnAccount && ['userProfile', 'userPosts', 'userLikes'].includes($route.name)">
                                                        Your posts
                                                    </span>
                                                    <span v-else-if="$root.isOwnAccount && $route.name === 'userDrafts'">
                                                        Your drafts
                                                    </span>
                                                    <span v-else>
                                                        Posts
                                                    </span>
                                                </h4>
                                            </a>
                                        </div>
                                    </router-link>
                                    <router-link v-if="$root.isOwnAccount"
                                        :to="
                                            '/u/' +
                                            $root.profile.username +
                                            ($root.community !== false
                                                ? '/' + $root.community.url
                                                : '') +
                                            '/liked'
                                        "
                                        v-slot="{
                                            href,
                                            route,
                                            navigate,
                                            isActive,
                                            isExactActive,
                                        }"
                                    >
                                        <div>
                                            <a :href="href" @click="navigate">
                                                <h4 :class="[!isExactActive && 'inactive',]">
                                                    Liked posts
                                                </h4>
                                            </a>
                                        </div>
                                    </router-link>
                                    <router-link v-if="$root.isOwnAccount"
                                        :to="'/u/' + $root.profile.username + '/reposts'"
                                        v-slot="{
                                            href,
                                            route,
                                            navigate,
                                            isActive,
                                            isExactActive,
                                        }"
                                    >
                                        <div>
                                            <a :href="href" @click="navigate">
                                                <h4 :class="[!isExactActive && 'inactive',]">
                                                    Reposts
                                                </h4>
                                            </a>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div class="profile__drafts" v-if="$root.isOwnAccount && ['userPosts', 'userDrafts'].includes($route.name)">
                            <router-link v-if="$route.name !== 'userDrafts'" :to="'/u/' + $root.profile.username + '/drafts'">View {{numDrafts}} draft posts</router-link>
                            <router-link v-else to="./posts">View {{numPosts}} live posts</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <Menu
                :show-menu="showFollowersMenu"
                :scroll-class="scrollClass"
                :close-event="closeProfileFollowersMenuEvent"
                :top="true"
            >
                <div>
                    <div class="menu__title">
                        <p>Followers</p>
                    </div>

                    <div class="menu__search followers">
                        <div class="search">
                            <input
                                type="text"
                                v-model="searchFollowers"
                                @keyup="getInput"
                                class="search"
                                placeholder="Search people"
                            >
                            <img v-if="showFollowersLoader" :src="$cdn('/img/ui/icon-loader-eclipse.svg')" alt="loading" width="30" height="30" class="search__small-loader search__active">
                            <img
                                @click="clearInput"
                                :class="['search__clear', { 'search__active' : searchActiveFollowers}]"
                                :src="$cdn('/img2.0/icons/close.svg')"
                                alt="Remove text"
                            >
                        </div>
                    </div>

                    <div class="menu__items">
                        <a :href="'/u/' + follower.username" class="following" v-for="follower in followers" :key="follower.id">
                            <img
                                :src="follower.avatar"
                                :alt="follower.name"
                                class="c-avatar c-avatar--40"
                            >
                            <div class="following__details">
                                <p>
                                    {{follower.name}}
                                    <span>@{{follower.username}}</span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </Menu>
            <Menu
                :show-menu="showFollowingMenu"
                :scroll-class="scrollClass"
                :close-event="closeProfileFollowingMenuEvent"
                :top="true"
            >
                <div>
                    <div class="menu__title">
                        <p>Following</p>
                    </div>

                    <div class="menu__search followings">
                        <div class="search">
                            <input
                                type="text"
                                v-model="searchFollowings"
                                @keyup="getInput"
                                class="search"
                                placeholder="Search people"
                            >
                            <img v-if="showFollowingsLoader" :src="$cdn('/img/ui/icon-loader-eclipse.svg')" alt="loading" width="30" height="30" class="search__small-loader search__active">
                            <img
                                @click="clearInput"
                                :class="['search__clear', { 'search__active' : searchActiveFollowings}]"
                                :src="$cdn('/img2.0/icons/close.svg')"
                                alt="Remove text"
                            >
                        </div>
                    </div>

                    <div class="menu__items">
                        <div class="following" v-for="(following, index) in followings" :key="following.id">
                            <a :href="'/u/' + following.username">
                                <img
                                    :src="following.avatar"
                                    :alt="following.name"
                                    class="c-avatar c-avatar--40"
                                >
                            </a>
                            <a :href="'/u/' + following.username" class="following__details">
                                <p>
                                    {{following.name}}
                                    <span>@{{following.username}}</span>
                                </p>
                            </a>
                            <a v-if="$root.isOwnAccount"
                               href="#"
                               class="following__unfollow"
                               @click.prevent="unfollowIndexed(index, parseInt(following.id), $event)"
                            >
                                <p>Unfollow</p>
                            </a>
                        </div>
                    </div>
                </div>
            </Menu>
        </section>

        <!-- Mobile profile description and website -->
        <!--
        <div
            class="o-wrapper u-hidden u-block@s u-order-4@s"
            v-if="this.$route.name === 'Communities'"
        >
            <div class="o-grid">
                <div class="o-grid__item u-width-full">
                    <div class="c-community__profile">
                        <p v-if="$root.profile.bio">
                            {{ $root.profile.bio }}
                        </p>
                        <a
                            v-if="$root.profile.website"
                            target="_blank"
                            :href="$root.profile.website"
                            >{{ $root.profile.website }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
        &lt;!&ndash; !Mobile profile description and website &ndash;&gt;
        <div
            class="c-profile__menu&#45;&#45;delete c-profile__menu&#45;&#45;delete-account"
        >
            <div class="o-grid o-grid&#45;&#45;center u-bg-white">
                <div
                    class="o-grid__item u-width-full u-a-center u-p-y6 u-p-x6"
                >
                    <img
                        :src="$cdn('/img/ui/cancel.svg')"
                        class="c-profile__menu&#45;&#45;close"
                        alt="Close Icon"
                    />
                    <h4 class="u-m-b2">Delete my Account</h4>
                    <p class="u-m-b3">
                        Are you sure you want to delete your {{ $root.brand.name }} account?
                    </p>
                    <button class="c-btn u-m-b3" @click="deleteConfirm">
                        Yes delete my account
                    </button>
                    <span
                        >Please note, your account can not be retrieved if
                        deleted.</span
                    >
                </div>
            </div>
        </div>
        -->

        <!-- load ProfileCommunities, ProfilePosts or ProfileLiked components based on URL as defined in router.js -->
        <router-view v-if="privateMessage === false"></router-view>

        <div v-if="privateMessage" class="o-wrapper">
            <div class="o-grid o-grid--center">
                <div class="o-grid__item u-width-7/12 u-width-full@l">
                    <div class="c-private">
                        <img
                            :src="$cdn('/img/ui/icon-private.svg')"
                            alt="Private Account"
                        />
                        <div>
                            <h5>This account is private</h5>
                            <p>
                                Follow this user to see their communities and
                                content
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import Menu from "../menu/Menu";
import CopyLink from "../CopyLink.vue";

export default {
    components: {
        CopyLink,
        Menu,
    },
    data() {
        return {
            searchActiveFollowers: false,
            searchActiveFollowings: false,
            closeProfileCommunitiesMenuEvent: 'bus-profile-communities-menu-close',
            closeProfileFollowersMenuEvent: 'bus-profile-followers-menu-close',
            closeProfileFollowingMenuEvent: 'bus-profile-following-menu-close',
            currentRoute: window.location.pathname,
            followers: [],
            followings: [],
            followingStats: this.$root.stats.following,
            isFollowing: null,
            shareSubject: 'Check out this ' + this.$root.brand.domain + ' User Profile',
            shareBody:
                'I found this user profile on ' + this.$root.brand.domain + ' and I thought you might like to check it out:\n\n' +
                window.location.href.replace(/^(.+\/u\/[^\/]+).*$/, '$1'),
            numDrafts: this.$root.stats.drafts,
            numPosts: this.$root.stats.posts,
            privateMessage: false,
            showCommunitiesMenu: false,
            showFollowersMenu: false,
            showFollowingMenu: false,
            showFollowersLoader: false,
            showFollowingsLoader: false,
            showIfFollowing: false,
            scrollClass: 'menu__content--scroll',
            searchActive: false,
            searchLoading: false,
            searchCommunity: '',
            searchFollowers: '',
            searchFollowings: ''
        };
    },
    created() {
        this.$root.$on(this.closeProfileFollowersMenuEvent, () => {
            this.toggleFollowersMenu(true);
        });
        this.$root.$on(this.closeProfileFollowingMenuEvent, () => {
            this.toggleFollowingMenu(true);
        });
        this.$root.$on(this.closeProfileCommunitiesMenuEvent, () => {
            this.toggleCommunitiesMenu(true);
        });
        this.$root.$on('bus-profile-search-loading', (loading) => {
            this.searchLoading = loading;
        });
        this.$root.$on('bus-profile-decrement-drafts', (data) => {
            this.numDrafts--;
        });
        this.$root.$on('bus-profile-decrement-posts', (data) => {
            this.numPosts--;
        });



        this.$root.$on('show-private-message', (data) => {
            if (this.$root.profile.private === true) {
                this.privateMessage = true;
            }
        });
        this.$root.$on('hide-private-message', (data) => {
            this.privateMessage = false;
        });

        if (this.$root.user !== false && this.$root.user.username !== this.$root.profile.username) {
            this.isUserFollowing();
        }
    },
    mounted() {
        if (typeof this.$refs.communitySearch != 'undefined') {
            this.$refs.communitySearch.querySelector('input').focus();
        }
    },
    computed: {
        searchPlaceholder() {
            const name = this.$root.profile.first_name;
            if (this.$route.name === 'userPosts') return `Search ${name}'s posts`;
            if (this.$route.name === 'userLikes') return `Search ${name}'s liked posts`;
            if (this.$route.name === 'userReposts') return `Search ${name}'s reposts`;
            return `Search ${name}'s communities`;
        },
        avatarAttrs() {
            const avatar = this.$root.profile.avatar;
            const path = avatar || '/img/avatar-default.svg';
            // Local server uploads (/media/) can't be served via CDN transform — no srcset possible
            if (avatar && avatar.indexOf('/media/') === 0) {
                return { src: avatar };
            }
            return {
                src: this.$simpleStore.transformImageWithCloudfront(120, 120, path, this),
                srcset: this.$simpleStore.transformImageWithCloudfront(120, 120, path, this, 'srcset'),
            };
        },
    },
    watch: {
        $route(to, from) {
            this.privateMessage = false;
            if (to.name !== from.name) {
                this.searchCommunity = '';
                this.searchActive = false;
                this.searchLoading = false;
            }
        },
    },
    methods: {
        clearInput(event) {
            // remove X to clear search
            const wrapper = event.target.closest('.profile__search, .followers, .followings');
            if (!wrapper) return;
            let searchInput = wrapper.querySelector('input');
            let searchType = this.getSearchType(wrapper);
            setTimeout(() => {
                switch (searchType) {
                    case 'community':
                        this.searchCommunity = '';
                        this.searchActive = false;
                        this.$root.$emit(this.searchEventForRoute(), '');
                        break;

                    case 'follower':
                        this.queryFollowers('');
                        this.searchFollowers = '';
                        break;

                    case 'following':
                        this.queryFollowing('');
                        this.searchFollowings = '';
                        break;
                }
            }, 200);

            if (searchInput) searchInput.focus();
        },
        getInput(event) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            let parent = event.target.parentNode.parentNode;
            let searchType = this.getSearchType(parent);
            // get input after 800ms i.e. once user has stopped typing
            this.timer = setTimeout(() => {
                let searchTerm = event.target.value;
                if (searchTerm.length > 0) {
                    this.searchActive = true;
                    switch (searchType) {
                        case 'community':
                            this.$root.$emit(this.searchEventForRoute(), searchTerm);
                            break;

                        case 'follower':
                            this.queryFollowers(searchTerm);
                            break;

                        case 'following':
                            this.queryFollowing(searchTerm);
                            break;
                    }
                } else {
                    this.clearInput(event);
                }
            }, 800);
        },
        searchEventForRoute() {
            switch (this.$route.name) {
                case 'userPosts':
                case 'userDrafts':  return 'profile-search-posts';
                case 'userLikes':   return 'profile-search-liked';
                case 'userReposts': return 'profile-search-reposts';
                default:            return 'bus-profile-search-community';
            }
        },
        getSearchType(parent) {
            if (parent.classList.contains('profile__search')) {
                return 'community';
            } else if (parent.classList.contains('followers')) {
                return 'follower';
            } else if (parent.classList.contains('followings')) {
                return 'following';
            }
        },
        isUserFollowing() {
            this.$http.post('/api/v1/isfollowing', { userId: this.$root.profile.user_id })
                .then((response) => {
                    this.isFollowing = response.data.isFollowing;
                    this.showIfFollowing = true;
                }, () => {});
        },
        follow() {
            this.$simpleStore.follow(this, this.$root.profile.user_id);
        },
        queryFollowers(search) {
            let followersData = {
                user_id: this.$root.profile.user_id,
                community_url: this.$root.community.url,
                search: search
            };
            this.showFollowersLoader = true;
            if (search.length === 0) {
                this.searchActiveFollowers = false;
            }
            this.$http.post('/api/v1/user/' + this.$root.profile.user_id + '/followers', followersData).then(response => {
                this.showFollowersLoader = false;
                if (search.length > 0) {
                    this.searchActiveFollowers = true;
                }
                this.followers = response.data.results;
                if (this.followers.length === 0) {
                    this.showEmptyMessage = true;
                } else {
                    for (let i = 1; i < response.data.total_pages; i++) {
                        let page = i + 1;
                        let followersPagedData = {
                            user_id: this.$root.profile.user_id,
                            community_url: this.$root.community.url,
                            search: search,
                            page: page
                        };
                        this.$http.get('/api/v1/user/' + this.$root.profile.user_id + '/followers', {params: followersPagedData}).then(response => {
                            this.followers.push.apply(this.followers, response.data.results);
                        }, response => {
                            console.log('Errored:');
                            console.log(response);
                        });
                    }
                }
            }, response => {
                if (response.status === 403) {
                    this.$root.$emit('show-private-message');
                }
            });
        },
        queryFollowing(search, closeImg) {
            let followingData = {
                user_id: this.$root.profile.user_id,
                community_url: this.$root.community.url,
                search: search
            };
            this.showFollowingsLoader = true;
            if (search.length === 0) {
                this.searchActiveFollowings = false;
            }
            this.$http.post('/api/v1/user/' + this.$root.profile.user_id + '/following', followingData).then(response => {
                this.showFollowingsLoader = false;
                if (search.length > 0) {
                    this.searchActiveFollowings = true;
                }
                this.followings = response.data.results;
                if (this.followings.length === 0) {
                    this.showEmptyMessage = true;
                } else {
                    for (let i = 1; i < response.data.total_pages; i++) {
                        let page = i + 1;
                        let pageData = {
                            user_id: this.$root.profile.user_id,
                            community_url: this.$root.community.url,
                            search: search,
                            page: page
                        };
                        this.$http.get('/api/v1/user/' + this.$root.profile.user_id + '/following', {params: pageData}).then(response => {
                            this.followings.push.apply(this.followings, response.data.results);
                        }, response => {
                            console.log('Errored:');
                            console.log(response);
                        });
                    }
                }
            }, response => {
                if (response.status === 403) {
                    this.$root.$emit('show-private-message');
                }
            });
        },
        toggleCommunitiesMenu(close) {
            if (close === true) {
                this.showCommunitiesMenu = false;
            } else {
                this.showCommunitiesMenu = !this.showCommunitiesMenu;
            }
        },
        toggleFollowersMenu(close) {
            this.showCommunitiesMenu = false;
            if (close === true) {
                this.showFollowersMenu = false;
                // only query backend if not done already
            } else if (this.showFollowersMenu === false && this.followers.length === 0) {
                this.showFollowersMenu = !this.showFollowersMenu;
                this.showFollowersLoader = true;
                this.$http
                    .post('/api/v1/user/' + this.$root.profile.user_id + '/followers')
                    .then((response) => {
                        this.showFollowersLoader = false;
                        this.followers = response.data.results
                    }, response => {
                        if (response.status === 403) {
                            console.log('Error: you cannot view a user\'s followers unless you a follow this user');
                        }
                    });
            } else if (this.showFollowersMenu === false && this.followers.length > 0) {
                this.showFollowersMenu = !this.showFollowersMenu;
            }
        },
        toggleFollowingMenu(close) {
            this.showCommunitiesMenu = false;
            if (close === true) {
                this.showFollowingMenu = false;
                // only query backend if not done already
            } else if (this.showFollowingMenu === false && this.followings.length === 0) {
                this.showFollowingMenu = !this.showFollowingMenu;
                this.showFollowingsLoader = true;
                this.$http
                    .post('/api/v1/user/' + this.$root.profile.user_id + '/following')
                    .then((response) => {
                        this.showFollowingsLoader = false;
                        this.followings = response.data.results
                    }, response => {
                        if (response.status === 403) {
                            console.log('Error: you cannot view the users being followed by a user unless you follow this user');
                        }
                    });
            } else if (this.showFollowingMenu === false && this.followings.length > 0) {
                this.showFollowingMenu = !this.showFollowingMenu;
            }
        },
        unfollowIndexed(index, userId, event) {
            this.$http.post('/api/v1/unfollow', { followedId: userId }).then(response => {
                let data = response.data;
                this.$delete(this.followings, index);
                this.followingStats--;

            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        followUser(userId) {
            this.$http.post('/api/v1/follow', { profileId: userId }).then(response => {
                let data = response.data;
                this.isFollowing = true;
                this.privateMessage = false;
                this.followingStats++;
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        unfollowUser(userId) {
            this.$http.post('/api/v1/unfollow', { followedId: userId }).then(response => {
                let data = response.data;
                this.isFollowing = false;
                this.$root.$emit('bus-profile-communities-reset-cache');
                this.$root.$emit('bus-profile-posts-reset-cache');
                this.$root.$emit('show-private-message');
                this.followingStats--;
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        deletePopUp() {
            $("body").find(".c-profile__menu--delete-account").addClass("open");
            $("body").addClass("faded-menu");
        },
        deleteConfirm() {
            $.ajax({
                url: "/settings/delete-account",
                type: "POST",
                cache: false,
                processData: false,
                contentType: false,
            }).done(function (response) {
                if (response.error == false) {
                    window.location.href = "/sign-out?deleted=true";
                }
            });
        },
    },
};
</script>
